<template>
  <div>
    <div class="row">
      <div class="formGroup col-8">
        <label for="address_1">
          Address Line 1
        </label>
        <input :disabled="disabled" type="text" id="address_1" v-model="value.address1"  @input="emitChangeAddress($event.target.value)" autocomplete="new-password">
      </div>
      <div class="formGroup col-8">
        <label for="address_2">
          Address Line 2
        </label>
        <input :disabled="disabled" type="text" id="address_2" v-model="value.address2"  @input="emitChangeAddress($event.target.value)" autocomplete="new-password">
      </div>
      <div class="formGroup col-6">
        <label for="city">
          City
        </label>
        <input :disabled="disabled" type="text" id="city" v-model="value.city"  @input="emitChangeAddress($event.target.value)" autocomplete="new-password">
      </div>
      <div class="formGroup col-5">
        <label for="state">
          State
        </label>
        <multiselect :disabled="disabled" autocomplete="new-password" v-model="value.state" :show-labels="true" :options="options" :placeholder="addressState"  @select="emitChangeAddress" :multiple="false"></multiselect>
      </div>
      <div class="formGroup col-5">
        <label for="zip">
          Zip
        </label>
        <input :disabled="disabled" type="text" id="zip" v-model="value.zip"  @input="emitChangeAddress($event.target.value)" autocomplete="new-password">
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'

export default {
  name: 'address-component',
  components: {
    Multiselect
  },
  data () {
    return {
      addressReturn: {
        address1: this.value.address1 || this.value.street_address || '',
        address2: this.value.address2 || '',
        city: this.value.locality || this.value.city || '',
        phone: '',
        state: this.value.region || this.value.state || '',
        zip: this.value.postal_code || this.value.zip || ''
      },
      state: [
        {abbr: 'AL', name: 'Alabama'},
        {abbr: 'AK', name: 'Alaska'},
        {abbr: 'AS', name: 'American Samoa'},
        {abbr: 'AZ', name: 'Arizona'},
        {abbr: 'AR', name: 'Arkansas'},
        {abbr: 'CA', name: 'California'},
        {abbr: 'CO', name: 'Colorado'},
        {abbr: 'CT', name: 'Connecticut'},
        {abbr: 'DE', name: 'Delaware'},
        {abbr: 'DC', name: 'District Of Columbia'},
        {abbr: 'FM', name: 'Federated States Of Micronesia'},
        {abbr: 'FL', name: 'Florida'},
        {abbr: 'GA', name: 'Georgia'},
        {abbr: 'GU', name: 'Guam'},
        {abbr: 'HI', name: 'Hawaii'},
        {abbr: 'ID', name: 'Idaho'},
        {abbr: 'IL', name: 'Illinois'},
        {abbr: 'IN', name: 'Indiana'},
        {abbr: 'IA', name: 'Iowa'},
        {abbr: 'KS', name: 'Kansas'},
        {abbr: 'KY', name: 'Kentucky'},
        {abbr: 'LA', name: 'Louisiana'},
        {abbr: 'ME', name: 'Maine'},
        {abbr: 'MH', name: 'Marshall Islands'},
        {abbr: 'MD', name: 'Maryland'},
        {abbr: 'MA', name: 'Massachusetts'},
        {abbr: 'MI', name: 'Michigan'},
        {abbr: 'MN', name: 'Minnesota'},
        {abbr: 'MS', name: 'Mississippi'},
        {abbr: 'MO', name: 'Missouri'},
        {abbr: 'MT', name: 'Montana'},
        {abbr: 'NE', name: 'Nebraska'},
        {abbr: 'NV', name: 'Nevada'},
        {abbr: 'NH', name: 'New Hampshire'},
        {abbr: 'NJ', name: 'New Jersey'},
        {abbr: 'NM', name: 'New Mexico'},
        {abbr: 'NY', name: 'New York'},
        {abbr: 'NC', name: 'North Carolina'},
        {abbr: 'ND', name: 'North Dakota'},
        {abbr: 'MP', name: 'Northern Mariana Islands'},
        {abbr: 'OH', name: 'Ohio'},
        {abbr: 'OK', name: 'Oklahoma'},
        {abbr: 'OR', name: 'Oregon'},
        {abbr: 'PW', name: 'Palau'},
        {abbr: 'PA', name: 'Pennsylvania'},
        {abbr: 'PR', name: 'Puerto Rico'},
        {abbr: 'RI', name: 'Rhode Island'},
        {abbr: 'SC', name: 'South Carolina'},
        {abbr: 'SD', name: 'South Dakota'},
        {abbr: 'TN', name: 'Tennessee'},
        {abbr: 'TX', name: 'Texas'},
        {abbr: 'UT', name: 'Utah'},
        {abbr: 'VT', name: 'Vermont'},
        {abbr: 'VI', name: 'Virgin Islands'},
        {abbr: 'VA', name: 'Virginia'},
        {abbr: 'WA', name: 'Washington'},
        {abbr: 'WV', name: 'West Virginia'},
        {abbr: 'WI', name: 'Wisconsin'},
        {abbr: 'WY', name: 'Wyoming'}
      ],
      options: [
        'Alabama',
        'Alaska',
        'American Samoa',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District Of Columbia',
        'Federated States Of Micronesia',
        'Florida',
        'Georgia',
        'Guam',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Marshall Islands',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Northern Mariana Islands',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Palau',
        'Pennsylvania',
        'Puerto Rico',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virgin Islands',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ],
      addressState: ''
    }
  },
  props: [
    'address',
    'disabled',
    'value'
  ],
  watch: {
    address: {
      deep: true,
      handler (newValue, oldValue) {
        this.value = newValue
      }
    }
  },
  computed: {
  },
  methods: {
    emitChangeAddress (value) {
      this.$emit('update', this.value)
    },
    addLatLong () {
      if (!this.value.latitude || !this.value.longitude) {
        axios.post('https://iu89nxrfub.execute-api.us-east-1.amazonaws.com/dev', {
          'address': this.value.address1 + ' ' + this.value.address2 + ' ' + this.value.city + ', ' + this.value.state + ' ' + this.value.zip
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../less/main.less';
</style>



// WEBPACK FOOTER //
// src/components/foundation/address.vue